const UpArrowIcon = ({
  className = "",
  width = 20,
  height = 14,
  fill = "none",
}) => {
  return (
    <svg
      width="23"
      height="12"
      viewBox="0 0 23 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 10.4231C0.5 10.5971 0.573847 10.7751 0.717198 10.9086C1.0039 11.1756 1.47305 11.1756 1.75975 10.9086L11.5728 1.76961L21.2424 10.7751C21.5291 11.0421 21.9983 11.0421 22.285 10.7751C22.5717 10.5081 22.5717 10.0712 22.285 9.80418L12.094 0.309144C11.8073 0.0421342 11.3382 0.0421342 11.0515 0.309144L0.717198 9.93364C0.569503 10.0712 0.5 10.2451 0.5 10.4231Z"
        fill="black"
      />
    </svg>
  );
};

export default UpArrowIcon;
